import equalByNameAndPaymentParamId from '../../utils/equalByNameAndPaymentParamId';
import {i18n} from "../../../vue-i18n";

export default class SetDiscount {
  constructor(paymentParametersId, newDiscount) {
    this.commandName = "SetDiscount";

    this.paymentParametersId = paymentParametersId;
    this.newDiscount = newDiscount;

    let discountRate = this.newDiscount.discountRate !== null ? `${this.newDiscount.discountRate}%` : '';
    let discountIsAuto = this.newDiscount.isAuto === true ? `${i18n.t('CONTENT.events.discount_rate_is_auto')}` : '';

    this.description =
      `${discountIsAuto}${discountRate}`
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewDiscount: this.newDiscount
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParamId(this, other);
}
